import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1034b706"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_2 = { class: "overlay" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, "Trailer Solutions", -1))
const _hoisted_5 = { class: "unauthorized-container" }
const _hoisted_6 = { class: "unauthorized-message" }
const _hoisted_7 = {
  key: 0,
  class: "session-content"
}
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "timeout-heading" }, " Session Expired ", -1))
const _hoisted_10 = { class: "timeout-text" }
const _hoisted_11 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unauthorized-heading" }, " Authentication Error ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unauthorized-text" }, " We were unable to sign you in. ", -1))
const _hoisted_14 = { class: "unauthorized-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isSessionTimeout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, " Your session has timed out. Please re-launch from your " + _toDisplayString(_ctx.returnApp) + " dashboard. ", 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, " Please contact your " + _toDisplayString(_ctx.contact) + " for further assistance. ", 1)
                ]))
          ]),
          _createVNode(_component_ReturnOptions, { company: _ctx.company }, null, 8, ["company"])
        ])
      ])
    ])
  ]))
}